export default "__VITE_PUBLIC_ASSET__fbba023c__"